"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "LaunchpadLogo___StyledSvg",
  componentId: "sc-3u2b09-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function LaunchpadLogo(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M17.632 2.368C17.381 2.118 17 2 16.434 2c-1.135 0-3.359.535-4.836 2.013L8.534 7.077H3.37a.78.78 0 00-.55.227l-.548.55a.777.777 0 000 1.097l8.778 8.777a.773.773 0 001.097 0l.549-.549a.775.775 0 00.226-.55v-5.164l3.065-3.064c1.115-1.115 1.607-2.555 1.8-3.312.157-.615.456-2.11-.155-2.721zm-10.65 6.26l-1.418 1.42-1.42-1.42h2.839zm-.321 2.517l5.486-5.486 2.194 2.194-5.485 5.486-2.195-2.194zm4.71 4.71l-1.418-1.418 1.419-1.42v2.838zM15.384 6.7l-2.085-2.085c1.086-.763 2.43-1.064 3.136-1.064h.021c.01.625-.281 2.023-1.072 3.15zM6.66 15.534c-.349.348-1.681.65-2.99.795.148-1.314.456-2.65.796-2.99.2-.2.445-.328.7-.396l-1.17-1.172a3.07 3.07 0 00-.627.47c-1.065 1.066-1.288 4.266-1.322 4.896L2 18l.863-.047c.631-.034 3.83-.259 4.895-1.323.19-.19.34-.404.47-.627l-1.171-1.172a1.527 1.527 0 01-.397.703z",
    fill: "currentColor"
  }));
}

var _default = LaunchpadLogo;
exports["default"] = _default;